<template>
  <div>
    <MobileHead />

    <el-container>
      <!-- <el-header style="height:56px"> -->
      <!-- </el-header> -->
      <div class="container">
        <el-container>
          <!-------右侧部分开始-------------->
          <el-main class="elmain">
               <router-view />
          </el-main>
          <!-------右侧部分结束-------------->
        </el-container>
      </div>
    </el-container>
  </div>
</template>

<script>
import { getExhition } from '../../../api/exhibitor';
import { logout } from '../../../api/login.js';
import { forMat, backExhibitionList } from '../../../utils/common';
import MobileHead from '../comment/mobile/mobileHead.vue';
import footBottom from '../comment/mobile/footMobile.vue';
export default {
  data() {
    return {
      //展商信息
      company: [],
      imgbaseUrl: forMat(),
      //展位信息
      boothList: {
        boothName: [], //展馆
        boothNum: [], //展位号
        bootTypeName: [], //展位类型
        boothArea: [], //展位面积
      },
    };
  },

  components: {
    MobileHead,
    footBottom,
  },

  computed: {},
  created() {
    this.getExhition();
  },

  methods: {
    async getExhition() {
      try {
        let { data } = await getExhition();
        this.company = data.data;
        this.boothList = {
          boothName: [], //展馆
          boothNum: [], //展位号
          bootTypeName: [], //展位类型
          boothArea: [], //展位面积
        };
        //如果展位信息为无
        if (this.company.hzBoothList.length === 0 || typeof this.company.hzBoothList === 'undefined') {
          return (this.boothList = {
            boothName: ['无'], //展馆
            boothNum: ['无'], //展位号
            bootTypeName: ['无'], //展位类型
            boothArea: [], //展位面积 不显示
          });
        }
        // 如果有展位信息
        if (this.company.hzBoothList.length > 0) {
          this.company.hzBoothList.forEach((item, index) => {
            this.boothList.boothName.push(item.boothName);
            this.boothList.boothNum.push(item.boothNum);
            this.boothList.bootTypeName.push(item.bootTypeName);
            this.boothList.boothArea.push(item.boothArea + 'm²');
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    addcomma(arr) {
      return arr.join('、');
    },
    editExhi() {
      this.$router.push('/mobileExhi');
    },
  },
};
</script>
<style lang="scss" scoped>
.homePage {
  width: 100vw;
  box-sizing: border-box;
  // border: 1px solid red;
  padding: 0 2.6vw 0 2.6vw;
  background: #f0f2f5;
  .exhibitor {
    width: 94.6vw;
    margin: 13.3vw 0 2.6vw 0;
    box-sizing: border-box;
    margin-top: 15.3vw;

    // padding: 17px 26px 26px 0;
    background: white;
    // border: 1px solid red;
    .title {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 0 9px 26px;
      border-bottom: 1px solid #e9e9e9;

      button {
        width: 24vw;
        height: 8.5vw;
        border: none;
        background: #006fb8;
        color: white;
        border-radius: 4px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 17px 26px 25px;

      .img {
        width: 192px;
        height: 108px;
        text-align: center;
        margin-right: 30px;

        img {
          max-width: 192px;
          max-height: 108px;
        }
      }

      .detail {
        // border: 1px solid red;
        width: 66%;
        p:first-child {
          margin-bottom: 2.6vw;
        }
        div i {
          line-height: 18px;
          // display: flex;
          font-size: 3.7vw;
          font-family: PingFangSC-Medium, PingFang SC;
          font-style: normal !important;
          font-weight: 500;
          color: #333333;
        }

        div:last-child {
          margin-top: 10px;
          .lastSpan {
            width: 200px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

        span {
          display: inline-block;
          width: 50%;
          font-size: 14px;

          white-space: nowrap;

          i {
            font-style: normal;
            font-size: 17px;
            margin-top: 5px;
            display: inline-block;
            width: 72%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .productBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 4vm;
    .box1 {
      width: 46vw;
      box-sizing: border-box;

      height: 20.53vw;
      margin-bottom: 2.6vw;
      padding: 4.8vw 2.8vw 2vw 7.2vw;
      display: flex;
      background: url('../../static/blueBG.png');
      font-size: 4.8vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      // line-height: 45px;
      .text {
        margin-left: 4vw;
        .miaoshu {
          font-size: 3.2vw;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.7);
        }
      }
      img {
        width: 9.3vw;
        height: 9.3vw;
      }
    }
    .box2 {
      background: url('../../static/yellowBG.png');
      color: #006fb8;
    }
  }
}
.el-container {
  width: 100vw;
}
</style>
<style scoped>
.container >>> .el-main {
  padding: 0;
}
</style>
